export default __webpack_public_path__ + "static/Consult-01 1-62ee1de622ca7ff82256fca1dba03de3.png";